import { all, fork, put, take, takeLatest } from 'redux-saga/effects';
import { selectAPI } from '../../api/API.sagas';
import {
    API_GET_APPLICATION,
    API_GET_APPLICATION_SUCCESS,
    API_GET_CUSTOMER_STATE,
    API_GET_CUSTOMER_STATE_SUCCESS,
    API_GET_PAYMENT_METHOD,
    API_GET_PAYMENT_METHOD_SUCCESS
} from '../../api/lendingAPI/LendingAPI.actions';
import { CLOSE_MODAL } from '../../iwModals/Modals.actions';
import {
    BLOCK_ROUTER,
    CONFIRM_REROUTING,
    UNBLOCK_ROUTER
} from '../../iwRouter/IwRouter.actions';
import {
    REGISTER_BANK_ACCOUNT_SUCCESS,
    REGISTER_DEBIT_CARD_SUCCESS,
    INITIALISE_PAYMENT_METHOD_DEBIT_CARD,
    TOGGLE_ADD_DEBIT_CARD_FORM
} from '../modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import { companyDetailsSagasWorker } from './companyDetails/CompanyDetails.sagas';
import {
    ACTIVATE_PROFILE,
    CANCEL_PROMPT,
    OPEN_PROMPT,
    PROFILE_CONFIRM_REROUTING,
    PROFILE_DATA,
    PROFILE_DATA_LOADING
} from './Profile.actions';
import { isProfileLocation } from './ProfileHelper';

export const profileSagaWorkers = createWorkersForPage({
    page: 'PROFILE',
    isInPageLocation: isProfileLocation,
    createPageFlowWorkers: () => [
        fork(profileConfirmReroutingWorker),
        fork(profilePageWorker),
        fork(openPromptWorker),
        fork(cancelPromptWorker),
        fork(closeModalOnDebitCardSuccessWorker),
        fork(editBankDetailsWorker),
        ...companyDetailsSagasWorker
    ]
});

function* profileConfirmReroutingWorker() {
    yield takeLatest(CONFIRM_REROUTING, function* (action) {
        if (isProfileLocation(action.location)) {
            yield put({
                type: PROFILE_CONFIRM_REROUTING,
                location: action.location
            });
        }
    });
}

function* openPromptWorker() {
    yield takeLatest(OPEN_PROMPT, function* () {
        yield put({ type: BLOCK_ROUTER });
    });
}

function* cancelPromptWorker() {
    yield takeLatest(CANCEL_PROMPT, function* () {
        yield put({ type: UNBLOCK_ROUTER });
    });
}

function* closeModalOnDebitCardSuccessWorker() {
    yield takeLatest(REGISTER_DEBIT_CARD_SUCCESS, function* () {
        yield put({ type: TOGGLE_ADD_DEBIT_CARD_FORM });
        yield put({ type: CLOSE_MODAL });
    });
}

function* editBankDetailsWorker() {
    yield takeLatest(REGISTER_BANK_ACCOUNT_SUCCESS, function* () {
        yield put({ type: CLOSE_MODAL });
    });
}

function* profilePageWorker() {
    yield takeLatest(ACTIVATE_PROFILE, function* () {
        yield put({ type: PROFILE_DATA_LOADING });

        yield all([
            put({ type: API_GET_CUSTOMER_STATE }),
            put({ type: API_GET_APPLICATION }),
            put({ type: API_GET_PAYMENT_METHOD })
        ]);
        yield all([
            take(API_GET_CUSTOMER_STATE_SUCCESS),
            take(API_GET_APPLICATION_SUCCESS),
            take(API_GET_PAYMENT_METHOD_SUCCESS)
        ]);

        const { customer_state, payment_method } = yield selectAPI();

        yield all([
            put({
                type: PROFILE_DATA,
                save: OPEN_PROMPT,
                customer_state,
                payment_method
            }),
            put({ type: INITIALISE_PAYMENT_METHOD_DEBIT_CARD }) // Needs to be initialised so component knows what to render
        ]);
    });
}
